import en from './en-US/index.json'
import nl from './nl-NL/index.json'
export default {
  'en-US': en,
  'nl-NL': nl,
}
